import widgets from '../../widgets';
import icons from '../../../icons';

/**
 * returns a garbage bin icon to handle deleting fsm instructions
 * @param {Object} params
 * @param {() => void} params.onDeleteState callback to handle deleting the fsm state
 * @param {boolean} params.isHidden
 * @returns {JQuery<HTMLElement>}
 */
export const deleteStateButton = ({ onDeleteState, isHidden }) => {
  return widgets.inlineButtonWithText(
    icons.removeCard,
    '',
    onDeleteState
  ).addClass(`ml_fsm_remove_state_button ${isHidden ? 'ml_fsm_hidden' : ''}`);
};
